var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionsActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "creation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.249,
    height: 40.249,
    viewBox: "0 0 40.249 40.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1231",
    "data-name": "Grupo 1231",
    transform: "translate(9.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1230",
    "data-name": "Grupo 1230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_950",
    "data-name": "Caminho 950",
    d: "M132.452,6.18A10.733,10.733,0,1,0,118.18,20.454l.572,1.5a1.983,1.983,0,0,0-.256,2.793q.031.038.065.074a2,2,0,0,0,1.489,3.354h5.367a2,2,0,0,0,1.489-3.354,1.983,1.983,0,0,0-.117-2.8q-.036-.033-.074-.065l.572-1.5A10.734,10.734,0,0,0,132.452,6.18Zm-7.036,20.652H120.05a.671.671,0,0,1,0-1.342h5.367a.671.671,0,1,1,0,1.342Zm0-2.683H120.05a.671.671,0,0,1,0-1.342h5.367a.671.671,0,1,1,0,1.342Zm1.074-4.808h0a.672.672,0,0,0-.359.376l-.669,1.753c-.016,0-.03,0-.046,0h-.671v-5.76l3.158-3.158-.949-.949L123.6,14.954a.67.67,0,0,0-.2.474v6.037h-1.342V15.429a.67.67,0,0,0-.2-.474L118.512,11.6l-.949.949,3.158,3.158v5.76h-.671c-.016,0-.03,0-.046,0l-.669-1.753a.672.672,0,0,0-.359-.376,9.391,9.391,0,1,1,7.514,0Z",
    transform: "translate(-112)",
    fill: "#d4af37"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1233",
    "data-name": "Grupo 1233",
    transform: "translate(0 29.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1232",
    "data-name": "Grupo 1232",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_951",
    "data-name": "Caminho 951",
    d: "M34.586,352H27.5a.672.672,0,0,0-.451.174l-6.947,6.316-7.6-6.335a.672.672,0,0,0-.43-.155h-6.5C.724,352,0,354.65,0,356.23v5.832a.67.67,0,0,0,.67.671H39.578a.67.67,0,0,0,.671-.67h0v-5.741C40.249,354.707,39.513,352,34.586,352Zm4.321,9.391H1.342V356.23c0-.714,0-2.888,4.23-2.888h6.26l7.863,6.553a.673.673,0,0,0,.881-.019l7.187-6.534h6.823c4.321,0,4.321,2.242,4.321,2.979Z",
    transform: "translate(0 -352)",
    fill: "#d4af37"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1235",
    "data-name": "Grupo 1235",
    transform: "translate(19.266 29.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1234",
    "data-name": "Grupo 1234",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_682",
    "data-name": "Ret\\xE2ngulo 682",
    width: 1.716,
    height: 3.432,
    fill: "#d4af37"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1237",
    "data-name": "Grupo 1237",
    transform: "translate(21.841 29.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1236",
    "data-name": "Grupo 1236",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_683",
    "data-name": "Ret\\xE2ngulo 683",
    width: 1.716,
    height: 1.716,
    fill: "#d4af37"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1239",
    "data-name": "Grupo 1239",
    transform: "translate(16.692 29.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1238",
    "data-name": "Grupo 1238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_684",
    "data-name": "Ret\\xE2ngulo 684",
    width: 1.716,
    height: 1.716,
    fill: "#d4af37"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1241",
    "data-name": "Grupo 1241",
    transform: "translate(5.737 0.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1240",
    "data-name": "Grupo 1240"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_685",
    "data-name": "Ret\\xE2ngulo 685",
    width: 1.342,
    height: 4.5,
    transform: "translate(0 1.2) rotate(-63.435)",
    fill: "#d4af37"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1243",
    "data-name": "Grupo 1243",
    transform: "translate(29.728 0.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1242",
    "data-name": "Grupo 1242",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_686",
    "data-name": "Ret\\xE2ngulo 686",
    width: 4.5,
    height: 1.341,
    transform: "translate(0 1.424) rotate(-18.451)",
    fill: "#d4af37"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1245",
    "data-name": "Grupo 1245",
    transform: "translate(2.963 8.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1244",
    "data-name": "Grupo 1244",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_687",
    "data-name": "Ret\\xE2ngulo 687",
    width: 4.29,
    height: 0.858,
    fill: "#d4af37"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1247",
    "data-name": "Grupo 1247",
    transform: "translate(32.995 8.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1246",
    "data-name": "Grupo 1246",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_688",
    "data-name": "Ret\\xE2ngulo 688",
    width: 4.29,
    height: 0.858,
    fill: "#d4af37"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1249",
    "data-name": "Grupo 1249",
    transform: "translate(5.066 17.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1248",
    "data-name": "Grupo 1248",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_689",
    "data-name": "Ret\\xE2ngulo 689",
    width: 4.5,
    height: 1.342,
    transform: "translate(0 2.012) rotate(-26.565)",
    fill: "#d4af37"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1251",
    "data-name": "Grupo 1251",
    transform: "translate(30.559 17.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1250",
    "data-name": "Grupo 1250",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_690",
    "data-name": "Ret\\xE2ngulo 690",
    width: 1.342,
    height: 4.5,
    transform: "translate(0 1.2) rotate(-63.435)",
    fill: "#d4af37"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1253",
    "data-name": "Grupo 1253",
    transform: "translate(18.408 9.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1252",
    "data-name": "Grupo 1252",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_691",
    "data-name": "Ret\\xE2ngulo 691",
    width: 3.432,
    height: 1.716,
    fill: "#d4af37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsActivity);
export default __webpack_public_path__ + "static/media/questionsActivity.a4e428e37476630b7410944e55cabb87.svg";
export { ForwardRef as ReactComponent };